import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LocalStorageService } from './local-storage.service';
import { HttpService } from './http.service';
import { CommonService } from './common.service';
import { UsersService } from './users.service';



@NgModule({
  imports: [
    CommonModule
  ],
  providers: [LocalStorageService, HttpService, CommonService, UsersService]
})
export class CoreModule { }
